import type { IExtractParams } from "@routes/types.ts";
import { generatePath } from "@routes/utils.ts";

const pathBase = `/members/:memberId/papers/:paperId/approve/`;

export type IPaperApprovePathParam = IExtractParams<typeof pathBase>;

export const paperApprove = {
  post: (params: IPaperApprovePathParam) => generatePath(pathBase, params),
};
